"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { useKeyPressEvent } from "react-use";
import type { ApiWave } from "@/generated/models/ApiWave";
import MemesArtSubmissionContainer from "./submission/MemesArtSubmissionContainer";
interface MemesArtSubmissionModalProps {
  readonly isOpen: boolean;
  readonly wave: ApiWave;
  readonly onClose: () => void;
}
const MemesArtSubmissionModal: React.FC<MemesArtSubmissionModalProps> = t0 => {
  const $ = _c(8);
  const {
    isOpen,
    wave,
    onClose
  } = t0;
  const modalRef = useRef(null);
  let t1;
  if ($[0] !== onClose) {
    t1 = () => onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useKeyPressEvent("Escape", t1);
  if (!isOpen) {
    return null;
  }
  let t2;
  if ($[2] !== isOpen || $[3] !== onClose || $[4] !== wave) {
    t2 = isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1000] tw-bg-gray-600/80 tw-backdrop-blur-sm tw-overflow-hidden" onClick={onClose}><div className="tw-fixed tw-inset-2 md:tw-inset-4 tw-flex tw-items-center tw-justify-center"><motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: "easeOut"
        }} className="tw-w-full tw-h-full tw-flex tw-flex-col" ref={modalRef} onClick={_temp}><div className="tw-h-full tw-overflow-hidden tw-flex tw-flex-col"><MemesArtSubmissionContainer onClose={onClose} wave={wave} /></div></motion.div></div></motion.div>;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = wave;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = createPortal(<AnimatePresence>{t2}</AnimatePresence>, document.body);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default MemesArtSubmissionModal;
function _temp(e) {
  e.stopPropagation();
}